import { render, staticRenderFns } from "./PressPDF.vue?vue&type=template&id=79fa6564&scoped=true&"
import script from "./PressPDF.vue?vue&type=script&lang=js&"
export * from "./PressPDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fa6564",
  null
  
)

export default component.exports